import { defineMessages } from "react-intl";

export const transactionRefundTilesMessages = defineMessages({
  defaultTransactionName: {
    defaultMessage: "Transaction",
    id: "se5+j/",
    description: "transaction refund tiles transaction name",
  },
  disabledTransaction: {
    defaultMessage: "This transaction is non-refundable.",
    id: "p12BmC",
    description: "transaction refund tiles disabled transaction",
  },
  charged: {
    defaultMessage: "Charged",
    id: "FmwGVb",
    description: "transaction refund tiles charged label",
  },
});
